import React from 'react'
import { array, bool, func, number, string } from 'prop-types'
import classnames from 'classnames'
import isDOMAvailable from 'utils/isDOMAvailable'

import Backdrop from 'components/atoms/Backdrop'
import SearchResultsCategory from 'components/atoms/SearchResultsCategory'
import SearchResultsGroup from 'components/molecules/SearchResultsGroup'
import AutoCompleteSearchNotFound from 'components/organisms/AutoCompleteSearchNotFound'

const SearchAutocomplete = ({
  isLoading,
  isNoResults,
  searchResults,
  autocompletePosition,
  onSelectItem,
  keyword,
  close,
  isNewSearch,
}) => (
  <div className={classnames('search__autocomplete', { 'new-search': isNewSearch })}>
    {
      isDOMAvailable &&
      <Backdrop
        parent={document.getElementById('header')}
        onClick={close}
      />
    }
    {
      isLoading &&
      <SearchResultsCategory icon="search" title="Searching . . . " isNewSearch={isNewSearch}/>
    }
    {
      searchResults.map((resultsGroup, idx) => (
        <SearchResultsGroup
          category={resultsGroup.text}
          results={resultsGroup.children}
          onSelectItem={onSelectItem}
          key={`srg-${resultsGroup.text}-${idx}`}
          isNewSearch={isNewSearch}
        />
      ))
    }
    {
      isNoResults &&
      <AutoCompleteSearchNotFound keyword={keyword}/>
    }
    <style jsx global>
      {`
        .search__autocomplete {
          position: fixed;
          top: ${autocompletePosition + 10}px;
          width: 100%;

          background: #fff;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          box-shadow: 0 0 4px 0 rgba(0,0,0,0.1);

          overflow-y: auto;
          z-index: 99;

          @media screen and (max-width: 1024px) {
            top: ${autocompletePosition + 17}px;
            left: 0;
            right: 0;
            bottom: 0;
            height: calc(100vh - 57px);
            padding-bottom: 64px;
          }

          @media screen and (min-width: 1025px) {
            max-height: 75vh !important;
          }

          &.new-search {
            top: ${autocompletePosition}px;
            color: #1a344f !important;
            @media screen and (max-width: 767px) {
              .search__results-item {
                padding: 12px 16px !important;
                &.active {
                  background-color: transparent;
                }
              }
            }
            @media screen and (min-width: 768px) {
              position: absolute;
              top: ${autocompletePosition - 21}px;
              border-radius: 10px;
              box-shadow: 0 6px 16px 0 rgba(107, 143, 188, 0.1), 0 2px 8px 0 rgba(26, 52, 79, 0.4);
              .submit-button {
                padding: 12px 28px !important;
                width: unset;
              }
              .form-group {
                padding-top: 0 !important;
              }
              .text-wrap {
                width: unset;
                padding: 0 16px;
              }
              .submit-close {
                margin: 8px 16px 24px !important;
              }
              p {
                font-size: 16px !important;
              }
              .search__results-category-icon {
                margin-left: 8px;
              }
              .search__results-category-text {
                font-size: 20px !important;
              }
              .search__results-item {
                margin: 4px 12px;
                padding: 8px 12px !important;
                &:hover {
                  border-radius: 10px;
                  background-color: #ebeef3;
                }
              }
            }
            p {
              color: #1a344f !important;
              text-align: center;
            }
            .search__results-category {
              margin: 24px 16px 12px !important;
            }
            .text-area {
              height: 40px;
              margin-bottom: 16px;
            }
            .radio-buttons__option {
              margin-right: 0.5rem;
              margin-bottom: 0.5rem;
              height: 40px;
              border-radius: 20px;
              border: solid 1px #a3b4ca;
              font-size: 12px;
              font-weight: bold;
              align-items: center;
              color: #7d92a9;
            }
            .radio-buttons__option.active {
              background-color: #1e90ff;
              border: none;
              color: #fff;
            }
            .submit-button {
              margin-top: 16px;
              font-weight: bold;
              padding: 12px;
              border: none;
            }
            .form-group {
              padding-top: 17px;
            }
            .submit-close {
              margin: 16px 16px 10px;
            }
          }
        }
      `}
    </style>
  </div>
)

SearchAutocomplete.propTypes = {
  isLoading: bool.isRequired,
  autocompletePosition: number,
  searchResults: array,
  isNoResults: bool,
  onSelectItem: func,
  close: func,
  keyword: string,
  isNewSearch: bool,
}

SearchAutocomplete.defaultProps = {
  autocompletePosition: 40,
  isNoResults: false,
  isNewSearch: false,
}

export default SearchAutocomplete
